module.exports = __webpack_public_path__ + "img/Mode_Selector_Turbo.be58b48b.png";